/**
 * TanStack Query hooks for `advertiser-portal`. Wraps api.ts.
 * All queries are keyed by advertiser id + range so switching advertiser or
 * window reissues the fetch.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	advertiserPortalQueryKeys,
	getCampaignReport,
	getDailyReport,
	listConversions,
	type CampaignReportResponse,
	type DailyReportResponse,
	type ListConversionsArgs,
	type ListConversionsResponse,
	type ReportArgs,
} from "./api";

export function useConversionsList(
	args: ListConversionsArgs,
): UseQueryResult<ListConversionsResponse, Error> {
	return useQuery({
		queryKey: advertiserPortalQueryKeys.conversionsList(args),
		queryFn: () => listConversions(args),
		enabled: Boolean(args.advertiserId),
	});
}

export function useDailyReport(
	args: ReportArgs,
): UseQueryResult<DailyReportResponse, Error> {
	return useQuery({
		queryKey: advertiserPortalQueryKeys.dailyReport(args),
		queryFn: () => getDailyReport(args),
		enabled: Boolean(args.advertiserId),
	});
}

export function useCampaignReport(
	args: ReportArgs,
): UseQueryResult<CampaignReportResponse, Error> {
	return useQuery({
		queryKey: advertiserPortalQueryKeys.campaignReport(args),
		queryFn: () => getCampaignReport(args),
		enabled: Boolean(args.advertiserId),
	});
}
